import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';

/**
 * NavRenderer - Renders navigation items with proper layout and conditional rendering
 *
 * @param {object} props - Props.
 * @param {React.Node} props.navItems - Main navigation items.
 * @param {React.Node} props.filterItems - Filter items component.
 * @param {React.Node} props.settingsButton - Settings button component.
 * @param {React.Node} props.additionalNavItems - Additional navigation items.
 * @param {React.Node} props.roundButtons - Round buttons component.
 * @param {Function} props.isFiltersVisibleHandler - Handler for filter visibility toggle.
 * @param {boolean} props.withScrollableFilter - Whether to use scrollable filter layout.
 * @param {boolean} props.showResponsiveItems - Whether to show responsive items.
 * @returns {React.Element} Component.
 */
export const NavRenderer = ({
    navItems,
    filterItems,
    settingsButton,
    additionalNavItems,
    roundButtons,
    isFiltersVisibleHandler,
    withScrollableFilter,
    showResponsiveItems
}) => {
    return (
        <>
            {navItems}

            {filterItems &&
                cloneElement(filterItems, {
                    isFiltersVisibleHandler
                })}

            {!!settingsButton &&
                !withScrollableFilter &&
                !showResponsiveItems && (
                    <div className="stats-leaders-nav__filter-button-wrapper">
                        {settingsButton}
                    </div>
                )}

            {!!additionalNavItems && (
                <div
                    className={`${
                        additionalNavItems.props.isResponsive
                            ? 'stats-leaders-nav__filter-button-responsive-wrapper'
                            : 'stats-leaders-nav__filter-button-wrapper'
                    } ${additionalNavItems.props.className || ''}`}
                >
                    {additionalNavItems}
                </div>
            )}

            {!!roundButtons && !withScrollableFilter && (
                <div className="stats-leaders-nav__round-buttons-wrapper">
                    {roundButtons}
                </div>
            )}
        </>
    );
};

NavRenderer.propTypes = {
    navItems: PropTypes.node,
    filterItems: PropTypes.node,
    settingsButton: PropTypes.node,
    additionalNavItems: PropTypes.node,
    roundButtons: PropTypes.node,
    isFiltersVisibleHandler: PropTypes.func.isRequired,
    withScrollableFilter: PropTypes.bool,
    showResponsiveItems: PropTypes.bool
};
